export default function* dashboardSaga() {
	// See example in containers/HomePage/saga.js
}
